import { createContext, useCallback, useEffect, useState } from 'react';
import type { FC } from 'react';
import PropTypes from 'prop-types';
import { ContextProviderProps } from 'src/types/contextProviderProps';
import { AlertColor } from '@mui/material';

export interface ISnackbarContext {
  isSnackActive: boolean;
  snackMessage: string;
  snackSeverity: AlertColor;
  snackTimeout: number;
  openSnackBar: (msg: string, severity?: AlertColor, timeout?: number) => void;
  closeSnackBar: () => void;
}

const SnackbarContext = createContext<ISnackbarContext>({
  isSnackActive: false,
  snackMessage: '',
  snackSeverity: 'success',
  snackTimeout: 3000,
  openSnackBar: () => {},
  closeSnackBar: () => {},
});

export const SnackbarProvider: FC<ContextProviderProps> = ({ children }) => {
  const [isSnackActive, setIsSnackActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState<string>('');
  const [snackSeverity, setSnackSeverity] = useState<AlertColor>('success');
  const [snackTimeout, setSnackTimeout] = useState<number>(3000);

  useEffect(() => {
    if (isSnackActive === true) {
      setTimeout(() => {
        setIsSnackActive(false);
      }, snackTimeout);
    }
  }, [isSnackActive, snackTimeout]);

  const openSnackBar = useCallback((msg: string, severity: AlertColor = 'success', timeout: number = 3000) => {
    console.log('openSnackBar', msg, severity, timeout);
    setSnackMessage(msg);
    setSnackSeverity(severity);
    setSnackTimeout(timeout);
    setIsSnackActive(true);
  }, []);

  const closeSnackBar = useCallback(() => {
    console.log('closeSnackBar');
    setIsSnackActive(false);
  }, []);

  return (
    <SnackbarContext.Provider
      value={{
        isSnackActive,
        snackMessage,
        snackSeverity,
        snackTimeout,
        openSnackBar,
        closeSnackBar,
      }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const SnackbarConsumer = SnackbarContext.Consumer;

export default SnackbarContext;
